module.exports = __webpack_public_path__ + "media/G.4172de40.wav";